export default __webpack_public_path__ + "static/media/INDICADORES.a8bef3bf.webp";